import React from "react"
import TableActionBar from "../../../../components/layout/TableActionBar"
import AppStateStore from "../../../../stores/AppStateStore"
import AddPicDialog from "../../../../components/picture/AddPicDialog"
import { FloatingActionButton, CircularProgress } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import autobind from "class-autobind"
import strings from "../../../../localization/strings"
import { IJobImage } from "../../../../models"
import * as api from "../../../../api"
import PictureTile from "../../../../components/picture/PictureTile"

interface IProps {
    readonly: boolean
    jobId: string
}
interface IState {
    loading: boolean
    openUploadPicDialog: boolean
    photos: IJobImage[]
    selectedPhotos: IJobImage[]
}

export default class JobDetailPhotos extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: true,
            openUploadPicDialog: false,
            photos: [],
            selectedPhotos: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getJobPhotos()
    }

    async getJobPhotos() {
        const res = await api.getJobImages(this.props.jobId)
        this.setState({
            loading: false,
            photos: res.data,
            selectedPhotos: []
        })
    }

    handleDelete(photos: IJobImage[]) {
        photos.length > 0 &&
            AppStateStore.setConfirmDialogContent({
                content: strings.Are_you_sure_you_want_to_delete_photo,
                confirm: async () => {
                    AppStateStore.setProgressSnackbarContent("loading")
                    await api.deleteJobImages(this.props.jobId, photos.map(i => i.Id))
                    await this.getJobPhotos()
                    AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
                }
            })
    }

    render() {
        return (
            <div style={{ padding: 20 }}>
                <FloatingActionButton
                    data-intercom-target={"menu-JobDetail-Photo-Btn-Add"}
                    style={{ position: "relative", float: "right", right: 50, top: -45 }}
                    secondary
                    onTouchTap={() => this.setState({ openUploadPicDialog: true })}
                >
                    <ContentAdd />
                </FloatingActionButton>
                <TableActionBar
                    rowSelectionCount={this.state.selectedPhotos.length}
                    singleSelectedMessage={strings.Photo_Selected}
                    multipleSelectedMessage={strings.x_Photos_Selected}
                    title={strings.Photos}
                    searchText={""}
                    onDeleteClick={() => this.handleDelete(this.state.selectedPhotos)}
                />
                <div style={{ overflow: "auto" }}>
                    {this.state.loading ?
                        <div style={{ textAlign: "center", marginTop: 30 }}>
                            <CircularProgress />
                        </div> :
                        this.state.photos.length === 0 ?
                            <h2 style={{ textAlign: "center" }}>{strings.No_Photo}</h2> :
                            this.state.photos.map((photo, index) =>
                                <div style={{ float: "left", margin: 10 }} key={index}>
                                    <PictureTile
                                        imageFixedHeight={150}
                                        imageUrlPropertyName="ImageUrl"
                                        picture={photo}
                                        selected={this.state.selectedPhotos.find(i => i.Id === photo.Id) ? true : false}
                                        handleChangeSelect={() => {
                                            let { selectedPhotos } = this.state
                                            if (selectedPhotos.find(i => i.Id === photo.Id)) {
                                                selectedPhotos = selectedPhotos.filter(i => i.Id !== photo.Id)
                                            }
                                            else {
                                                selectedPhotos.push(photo)
                                            }
                                            this.setState({ selectedPhotos })
                                        }}
                                        handleDelete={() => this.handleDelete([photo])}
                                        disabled={this.props.readonly}
                                    />
                                </div>
                            )
                    }
                </div>
                {this.state.openUploadPicDialog &&
                    <AddPicDialog
                        handleSave={async (files) => {
                            AppStateStore.setProgressSnackbarContent("loading")
                            let index = 0
                            while (index < files.length) {
                                const file = files[index]
                                await api.addJobImage(this.props.jobId, file);
                                index++
                            }
                            await this.getJobPhotos()
                            AppStateStore.setProgressSnackbarContent(strings.Successfully_added)
                        }}
                        handleClose={() => this.setState({ openUploadPicDialog: false })}
                    />
                }
            </div>
        )
    }
} 